import { render, staticRenderFns } from "./amazonChannelTextOnly.vue?vue&type=template&id=ebb006ec&scoped=true"
import script from "./amazonChannelTextOnly.vue?vue&type=script&lang=js"
export * from "./amazonChannelTextOnly.vue?vue&type=script&lang=js"
import style0 from "./amazonChannelTextOnly.vue?vue&type=style&index=0&id=ebb006ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb006ec",
  null
  
)

export default component.exports